import { render, staticRenderFns } from "./unreadTopics.vue?vue&type=template&id=c3881a72"
import script from "./unreadTopics.vue?vue&type=script&lang=js"
export * from "./unreadTopics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports